<template>
  <section class="container mb-15">
    <h2 class="tit-st02 mb-2">주문취소</h2>
    <div class="tbwrap">
      <table class="tb-st use mb-10">
        <tbody>
          <tr>
            <th>주문취소 가능 시점</th>
            <td>
              회원은 상품 주문 및 결제 완료 후 주문을 취소할 수 있습니다. <br />
              단, 주문 취소는 결제 완료 상태일 때 언제든지 가능합니다. 이미 배송
              준비 중인 경우에는 반품 절차를 따라야 합니다.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="tit-st02 mb-2">배송 안내</h2>
    <div class="tbwrap">
      <table class="tb-st use mb-10">
        <tbody>
          <tr>
            <th>배송업체</th>
            <td>CJ 대한통운</td>
          </tr>
          <tr>
            <th>배송비</th>
            <td>
              회원의 결제 금액 기준 99,000원 이상 상품 구매 시 배송비는
              무료이며, 99,000원 미만인 경우 2,500원의 기본 배송비가 부과됩니다.
              <br />
              기본 배송비는 변경될 수 있으며 변경될 경우 회사는 상품 대금 결제
              시 이를 안내해 드립니다.
            </td>
          </tr>
          <tr>
            <th>배송 기간</th>
            <td>
              <ul>
                <li>
                  ① 주문하신 상품이 오후 2시 이전 결제 완료된 경우 당일
                  발송되며, 오후 2시 이후 결제 완료된 경우 영업일 기준 익일에
                  발송됩니다. 단, 회사의 상품 발송 후 2~3일 정도의 배송 기간이
                  소요되며 택배사의 물류 사정에 따라 지연될 수 있습니다.
                </li>
                <li>
                  ② 월 말이나 월초, 연휴 기간의 주문이거나 배송지가 도서, 오지,
                  산간 지역일 경우 2~3일 정도 배송이 지연될 수 있습니다.
                </li>
                <li>
                  ③ 토, 일요일 주문 건은 월요일에 발송 처리되오니 주문 시 참고
                  부탁드립니다.
                </li>
                <li>
                  ④ 상품 중 스프레이류, 방향제, 염모제는 항공 운송 상 안전 상의
                  이유로 항공 운송 거부 품목에 해당되며, 제주 및 도서 지역은
                  배편을 이용하여 배송되며, 배송 기간이 추가될 수 있습니다.
                </li>
                <li>
                  ⑤ 군부대 및 민간인 출입이 제한되는 지역은 택배 수령이 불가한
                  경우가 있으니 주문 시 참조해 주십시오.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="tit-st02 mb-2">반품 기준</h2>
    <div class="tbwrap">
      <table class="tb-st use mb-10">
        <tbody>
          <tr>
            <th>반품 기준</th>
            <td>
              <ul>
                <li>
                  ① 미개봉, 미사용 상태(QR 스티커가 뜯어지지 않은 상태)의 손상
                  및 변질이 없는 상품만 반품이 가능합니다. 사용하신 상품은
                  반품이 일체 허용되지 않습니다.
                </li>
                <li>
                  ② 키트, 프로모션, 패키지 상품을 반품하는 경우, 또는 사은품이
                  함께 지급되는 상품을 반품하는 경우, 주문한 상품 외에 함께
                  제공된 증정 상품 및 사은품 등을 포함하여 배송받은 모든
                  내용물을 반환하여야 합니다.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>반품 시 제한 사항</th>
            <td>
              <ul>
                <li>
                  ① 판매점 또는 뷰티플래너의 책임 있는 사유로 재화 등이 멸실
                  또는 훼손된 경우
                </li>
                <li>② 구매일로부터 3개월을 초과한 경우</li>
                <li>
                  ③ 판매점 및 뷰티플래너의 사용 또는 일부 소비에 의하여 재화
                  등의 가치가 현저히 감소한 경우
                </li>
                <li>
                  ④ 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인
                  재화 등의 포장을 훼손한 경우
                </li>
                <li>
                  ⑤ 본인의 동일 주문 건에 해당하지 않는 제품으로 입고될 경우
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>반품 기간 및 환불 기준</th>
            <td>
              <ul>
                <li>
                  ① 소비자의 경우 주문 상품 인도일로부터 14일 이내
                  청약철회(반품)가 가능하며, 뷰티플래너의 경우 영업관리 규정에
                  따라 청약철회가 가능합니다.
                </li>
                <li>
                  ② 청약철회(반품) 비용 공제는 아래와 같습니다.
                  <ul>
                    <li>
                      - 상품 공급일로부터 1개월 경과 2개월 이내 반품 시 상품
                      금액의 5% 공제
                    </li>
                    <li>
                      - 상품 공급일로부터 2개월 경과 3개월 이내 반품 시 상품
                      금액의 7% 공제
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>반품 절차</th>
            <td>
              <ul>
                <li>
                  ① ㈜리만코리아 판매점 통합지원센터(TEL. 1522-8144)를 통한 반품
                  신청서 접수 (FAX. 053-766-9878 / E-MAIL.
                  return@rimankorea.co.kr)
                </li>
                <li>
                  ② 택배사를 이용하여 ""경기도 군포시 부곡동 451번지
                  한국복합물류 C동 2층 KBCI 물류센터""로 반품할 상품 발송
                </li>
                <li>
                  ③ 반품된 상품의 상태를 확인한 이후 3영업일 이내에 환불
                  처리(카드 결제의 경우 카드사의 사정에 따라 처리시간이 추가로
                  소요됨)
                </li>
              </ul>
              ※ 상품 입고 후 2~3일 정도 검수 및 확인 작업시간이 소요될 수
              있습니다.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="tit-st02 mb-2">교환 안내</h2>
    <div class="tbwrap">
      <table class="tb-st use">
        <tbody>
          <tr>
            <th>교환 안내</th>
            <td>
              회원이 구입한 상품을 구입 후 3개월 내에 상품에 하자 또는 결함이
              있어 동일 상품으로 교환 요청 시 3개월 품질보증제도에 의거 동일
              상품으로 교환 가능합니다.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Information',
};
</script>

<style></style>
